module.exports = __webpack_public_path__ + "static/media/wallTop.91904dcf.png";